<app-control-panel
  #panel
  [records]="(records$ | async) || []"
  (refresh)="onRefresh()"
>
  <ng-container ngProjectAs="button">
    <button
      appearance="accent"
      size="m"
      tuiIconButton
      icon="tuiIconShield"
      (click)="control$.next()"
    ></button>
  </ng-container>
</app-control-panel>
